
import "react-input-range/lib/css/index.css";
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import InputRange from 'react-input-range';
import { CirclePicker    } from 'react-color';
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Canvas from "./Canvas";
import { withRouter } from "react-router-dom";
import {
  faExclamationCircle,
  faCamera,
  faRedo,
  faUndo,
  faPencilAlt,
  faEraser,
  faCheck,
  faCircle
} from "@fortawesome/fontawesome-free-solid";




class VideoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: "",
      capture: false,
      loaded: false,
      vWrapperW: null,
      vWrapperH: null,
      snap: false,
      pensize: 10,
      erasesize: 10,
      penEnabled: true,
      eraserEnabled: false,
      activeColor: '#f44336',
      cameraFront: false,
      deviceCamera: {},
      screenScale: 0,
      video: {}
    };
    this.onClickHandler = this.onClickHandler.bind(this);
    this.InitializeVideo = this.InitializeVideo.bind(this);
    this.reInitializeVideo = this.reInitializeVideo.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.onClickBackHandler = this.onClickBackHandler.bind(this);
    this.gotDevices = this.gotDevices.bind(this);
    this.mediaStream = null;
    this.cameraID = {}
  }

  
  componentDidMount() {
    navigator.mediaDevices.enumerateDevices()
        .then(this.gotDevices);
    // this.InitializeVideo();
    
    window.addEventListener("resize", this.updateDimensions);
    
  }
  
  updateDimensions() {
    // console.log("update dimension")
    if(!this.state.capture){
      // var videoWrapperW= document.getElementById("video_wrapper").offsetWidth;
      // var videoWrapperH = document.getElementById("video_wrapper").offsetHeight;
      
      // this.setState({
      //   vWrapperW: videoWrapperW, 
      //   vWrapperH: videoWrapperH
      // });
      this.InitializeVideo()
    }
  }
  reInitializeVideo() {
    this.setState({ capture: false, loaded: false },this.InitializeVideo);
  }

  gotDevices(mediaDevices) {
    // console.log("gotdevices")
    // var cameraOptions = document.getElementById('cameraOptions');
    // cameraOptions.innerHTML = '';
    // cameraOptions.appendChild(document.createElement('option'));
    let count = 0;

    var deviceCameraID = {};  
    // console.log("mediaDevices:" + JSON.stringify(mediaDevices))
    mediaDevices.forEach(mediaDevice => {
      if (mediaDevice.kind === 'videoinput') {
        // const option = document.createElement('option');
        // option.value = mediaDevice.deviceId;
        deviceCameraID[count++] = mediaDevice.deviceId;
        // const label = mediaDevice.label || `Camera ${count++}`;
        // const textNode = document.createTextNode(label);
        // option.appendChild(textNode);
        // cameraOptions.appendChild(option);
      }
    });
    
    this.setState({ deviceCamera: deviceCameraID}, () => this.InitializeVideo())
  }

  InitializeVideo() {
    
    var switchCameraBtn = document.getElementById('switchCameraBtn');
    var cameraOptions = document.getElementById('cameraOptions');
    var videoWrapperW= document.getElementById("video_wrapper");
    if(videoWrapperW) {
      videoWrapperW = videoWrapperW.offsetWidth;
      this.setState({ vWrapperW: videoWrapperW });
    }
    // var videoWrapperH = document.getElementById("video_wrapper").offsetHeight;
    // videoWrapperW = (this.state.vWrapperW) ? this.state.vWrapperW : videoWrapperW;
    // videoWrapperH = (this.state.vWrapperH) ? this.state.vWrapperH : videoWrapperH;

    this.doResize();

    // if(videoWrapperW){
    //   this.setState({
    //     vWrapperW: videoWrapperW, 
    //     vWrapperH: videoWrapperH
    //   });
    // }
    
    // console.log("videoWrapperW:" + videoWrapperW)
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia  ||
      navigator.msGetUserMedia;

    if (navigator.getUserMedia && !this.state.capture) {
      
      if (typeof this.mediaStream !== 'undefined' && this.mediaStream !== null) {
        this.stopMediaTracks(this.mediaStream);
      }

      var constraints = {
        audio: false,
        video: {
          deviceId: { exact: "environment" }
        }
      };

      // console.log("videoWrapperH:" + videoWrapperH)

      if (!this.state.cameraFront) {
        constraints.video.deviceId = { exact: this.state.deviceCamera[1] };
      } else {
        constraints.video.deviceId = { exact: this.state.deviceCamera[2] };
      }

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(localMediaStream => {
          this.setState({ loaded: true }, () => {
            var video = document.getElementById("video_capture");
                video.srcObject = localMediaStream;
          });

          this.mediaStream = localMediaStream;
          return navigator.mediaDevices.enumerateDevices();
        })
        .catch(err => {
          // window.location.reload(); 
          this.setState({ errors: "An error has occurred - please refresh the page" });
        })
    } else {
      this.setState({ errors: "Media is not supported" });
    }
    
  }

  doResize(){
    var scaleableWrapperW = document.getElementById("scaleable_wrapper").offsetWidth;
    var scaleableWrapperH = document.getElementById("scaleable_wrapper").offsetHeight;
    var autoscaleContainerW = document.getElementById("autoscale_container").offsetWidth;
    var autoscaleContainerH = document.getElementById("autoscale_container").offsetHeight;

    var scale, origin;

    scale = Math.min(
      scaleableWrapperW / autoscaleContainerW,    
      scaleableWrapperH / autoscaleContainerH
    );

    this.setState({ screenScale: scale })
  }

  stopMediaTracks(stream){
    stream.getTracks().forEach(track => track.stop());
  }
  onClickHandler(video) {
    this.setState({
      capture: true,
      video
    });
  }

  onClickBackHandler(){
    var stream = this.mediaStream;
    stream.getTracks().forEach(track => track.stop());
    this.props.history.push("/nigoki");
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.capture !== this.state.capture){
      window.removeEventListener("resize", this.updateDimensions);
    }else{
      window.addEventListener("resize", this.updateDimensions);
    }

    if(prevState.cameraFront !== this.state.cameraFront){
      this.reInitializeVideo();
    }
  }

  componentWillUnmount(){
    window.removeEventListener("resize", this.updateDimensions);
  }
  
  render() {
    const sclateStyle = { transform: `translate(-50%, -50%) scale(${this.state.screenScale < 1 ? this.state.screenScale : 1})` };
    const deviceCount =  Object.keys(this.state.deviceCamera).length;
    
    return (
      <div>
        <div className="paper-bg-container"></div>
          {this.state.errors ? (
            <div
              className="card red white-text valign-wrapper"
              style={{ padding: "10px" }}
            >
              <FontAwesomeIcon icon={faExclamationCircle} size="3x" />
              <div style={{ paddingLeft: "20px" }}>{this.state.errors}</div>
            </div>
          ) : (
            <div>
            <div className="scaleable-wrapper" id="scaleable_wrapper">
              <img src="https://s3-ap-southeast-1.amazonaws.com/edgedigital.sg/tuckandrose/Design/Images/mobile/m-flower-1.png" className="n-flower-1-2 n-flower" alt=""/>
              <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-2.png" className="n-flower-12 n-flower" alt=""/>
              <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-5.png" className="n-flower-13 n-flower" alt=""/>
              <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-1.png" className="n-flower-14 n-flower" alt=""/>
              <div className="autoscale-container" id="autoscale_container" style={sclateStyle}>
              <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-6.png" className="n-flower-3-2 n-flower" alt=""/>
              {!this.state.capture ? (
                <div>
                  <div className="paper-bg">
                    <div className="video-bg">
                    { deviceCount > 1 ? (
                      <div className="flipCamera" onClick={ () => this.setState({ cameraFront: !this.state.cameraFront}) }>
                      <FontAwesomeIcon icon={faUndo} size="3x"/>
                      <FontAwesomeIcon icon={faCamera} className="camera-inside" />
                    </div>
                    ) : null } 
                        <div id="video_wrapper">
                        {this.state.loaded ? (
                          <div>
                            <video id="video_capture" autoPlay muted playsInline />
                          </div>
                        ) : null}
                        </div>
                    </div>
                  </div>
                  <div className="vwrapper-container btn-wrapper">
                    <div className="vwrapper">
                      <div className="center capture-left">
                        <img src="https://s3-ap-southeast-1.amazonaws.com/edgedigital.sg/tuckandrose/Design/Images/sm-top-tr-element.png" width="100%" alt="" />
                        <h5>Show Off Those Beautiful <span className="c-purple f-bold">Pearls</span>.</h5>
                        <img src="https://s3-ap-southeast-1.amazonaws.com/edgedigital.sg/tuckandrose/Design/Images/sm-bottom-tr-element.png" width="100%" alt="" />
                      </div>  
                      <div className="btn-purple capture-label" onClick={() => this.onClickBackHandler()}>
                        <div className="center-align">
                            Back
                        </div>
                      </div>
                      <div className="btn-purple capture-label" onClick={() => this.onClickHandler(document.getElementById("video_capture"))}>
                        <div className="center-align">
                            Snap!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="vwrapper-container btn-wrapper">
                    <div className="vwrapper">
                      {this.state.capture ? (
                        <div>
                          <div className="user-control-l">
                            <div className="btn-gray valign-wrapper user-control-label">
                              <div className="center-align w-100">
                                <FontAwesomeIcon
                                  icon={faPencilAlt}
                                  className={this.state.penEnabled ? "active" : ""}
                                  onClick={() =>
                                    this.setState({ penEnabled: true, eraserEnabled: false })
                                  }
                                />
                                <InputRange
                                    maxValue={20}
                                    minValue={5}
                                    value={this.state.pensize}
                                    onChange={value => this.setState({ pensize: value })} />
                              </div>
                            </div>
                            <div className="btn-gray valign-wrapper user-control-label">
                              <div className="center-align w-100">
                                <FontAwesomeIcon
                                  icon={faEraser}
                                  className={this.state.eraserEnabled ? "active" : ""}
                                  onClick={() =>
                                    this.setState({ eraserEnabled: true, penEnabled: false})
                                  }
                                />
                                <InputRange
                                    maxValue={20}
                                    minValue={5}
                                    value={this.state.erasesize}
                                    onChange={value => this.setState({ erasesize: value })} />
                              </div>
                            </div>
                            {/* <div className="btn-gray valign-wrapper user-control-label"> */}
                              {/* <div className="center-align w-100"> */}
                                <CirclePicker  
                                  color={ this.state.activeColor }
                                  onChangeComplete={ color => this.setState({ activeColor: color.hex })}
                                  circleSize={30}
                                />
                              {/* </div> */}
                            {/* </div> */}
                          </div>
                          <div className="user-control-r">
                            <div className="btn-purple capture-label" onClick={() => this.reInitializeVideo()}>
                              <div className="center-align">
                                <FontAwesomeIcon
                                  icon={faRedo}
                                />
                                  Retake
                              </div>
                            </div>
                            <div className="btn-purple capture-label" onClick={() => this.clickChild()}> 
                              <div className="center-align">
                                <FontAwesomeIcon
                                  icon={faCheck}
                                />
                                  Save
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                      null
                      )}
                    </div>
                  </div>
                  <Canvas
                    reinitUpStatus={this.props.reinitUpStatus}
                    uploadStatus={this.props.uploadStatus}
                    sendDrawing={this.props.sendDrawing}
                    screenCapture={this.state.video}
                    vWrapper={this.state.vWrapperW}
                    reinitializeVideo={this.reInitializeVideo}
                    mediaStream={this.mediaStream}
                    updatePenSize={this.state.pensize}
                    updateEraserSize={this.state.erasesize}
                    penEnabled={this.state.penEnabled}
                    eraserEnabled={this.state.eraserEnabled}
                    activeColor={this.state.activeColor}
                    setClick={click => this.clickChild = click}
                  />
                </div>
              )}
              </div>
              </div>
            </div>
           
          )}
      </div>
    );
  }
}

export default withRouter(VideoComponent);

const styles = {
  drawinfo: {
    position: "fixed",
    whiteSpace: "nowrap",
    right: "100px",
    color: "white"
  }
};


// WEBPACK FOOTER //
// ./src/components/VideoComponent.js